import { Link } from '@tanstack/react-router'

import { buttonVariants } from '@gto/ui/button'
import { Typography } from '@gto/ui/typography'

export const DefaultNotFoundPage = () => {
  return (
    <div className="flex size-full min-h-[100dvh] flex-col items-center justify-center gap-6 p-6">
      <Typography
        className="text-[80px] md:text-[120px]"
        color="primary"
        variant="h1"
      >
        404
      </Typography>
      <Typography
        color="text.primary"
        variant="h5"
      >
        Page not found
      </Typography>
      <Typography
        color="text.secondary"
        variant="body2"
      >
        The page you are looking for does not exist.
      </Typography>
      <Link
        className={buttonVariants({ color: 'primary', variant: 'contained' }).root()}
        to="/"
      >
        Back to admin home
      </Link>
    </div>
  )
}
